import { useState } from 'react'

export interface UseAssetFilerSettingsHook {
  assetFilterSettings: string[]
  updateAssetFilterSettings: (key: string, itemsArray: string[], checked: boolean) => void
}

export default function useAssetFilterSettings(): UseAssetFilerSettingsHook {
  const [state, setState] = useState<string[]>([])

  return {
    assetFilterSettings: state,
    updateAssetFilterSettings: (
      key: string,
      itemsArray: string[],
      checked: boolean,
      isRemoved?: string
    ) => {
      if (isRemoved) {
        // Reset state if isRemoved is true
        return setState([])
      }
      if (!checked) {
        // Remove key from state if unchecked
        const newArray = state.filter((item) => item !== key)
        setState(newArray)
      } else {
        // Add key to state if checked
        setState([...state, key])
      }
    },
  }
}
